import { ApiQueryConfig, ServicePathParams } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type GetServiceSchemaConfig = ApiQueryConfig<string, ServicePathParams>;

export const getServiceSchema = createApiEndpoint<GetServiceSchemaConfig>({
  url: `${URLS.app}/api/Services/$serviceId/Schema`,
  method: 'GET',
});
